// Illustrative renders only — they do not depict real AFB projects.
// Replace with approved AFB product photography when supplied.
export const images = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/e75b3960-1a3a-4e46-a25d-a4c063acbb8a.jpg',
  flagship:
    'https://cdn.magicpatterns.com/patterns/generated-images/92314a50-a0e6-4004-bc09-a01687481a20.jpg',
  delivery:
    'https://cdn.magicpatterns.com/patterns/generated-images/4112fc1b-7da3-4056-b710-b770f0cca2a8.jpg',
  hybrid: 'https://cdn.magicpatterns.com/patterns/generated-images/afe61b35-bb9d-4c12-8e96-c9d297dd4ee4.jpg',
  utility:
    'https://cdn.magicpatterns.com/patterns/generated-images/d422aaac-6ecc-4b1b-ab91-5cbc54666037.jpg',
}
